import styled from 'styled-components/macro';
import Triangle from 'images/ct-triangle.svg';

export const Heading = styled.h2`
  font-size: ${({ theme }) => theme.fontSizePalette.xLarge};
  font-weight: ${({ theme }) => theme.fontWeightPalette.bold};;
  line-height: 1.3;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colorPalette.grey.grey9};
  padding-bottom: 20px;
`

export const ButtonWrapper = styled.div`
  margin-top: auto;
  padding-top: 20px;
`

export const CardWrapper = styled.div`
  position: relative;
  background: url('${Triangle}') no-repeat -70px center;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colorPalette.white};
  padding: 20px;
  border-radius: 8px;
  width: 378px;
  min-height: 399px;
  box-shadow: ${({ theme }) => theme.boxShadowPalette.medium};
  overflow: hidden;
`
